import {Injectable} from '@angular/core';
import {UtilConfig} from './UtilConfig';
import {Headers, Http} from '@angular/http';
import {Observable} from 'rxjs/Observable';

@Injectable()
export class SecurityConfigService {
    URL_WS_CONFIGURATION = "/seguridad/configuracion/obtenerConfig";

    constructor(private http: Http, private jwtutil: UtilConfig) {
    }

    obtenerConfiguracion(user: string, pruc: string, idCustomer: number): Observable<any> {
        let url = this.jwtutil.URL_WS_BACKEND + this.URL_WS_CONFIGURATION;
        let usuarioVar = {username: user};
        let body = JSON.stringify({usuario: usuarioVar, ruc: pruc, customer: {id: idCustomer}});
        let headers = new Headers({'Content-Type': 'application/json; charset=UTF-8'});

        return this.http.post(url, body, {headers: headers})
            .catch((error: any) => Observable.throw(error.json().error || 'Server error'));
    }
}


// WEBPACK FOOTER //
// C:/Users/Natalia.Morales/IdeaProjects/datagate/administrator/frontend/src/main/webapp/src/app/autenticacion/servicios/security-config.service.ts